import { render, staticRenderFns } from "./AccountSkeleton.vue?vue&type=template&id=1dc9644d"
import script from "./AccountSkeleton.vue?vue&type=script&lang=js"
export * from "./AccountSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AccountSkeleton.vue?vue&type=style&index=0&id=1dc9644d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports